import {Component, inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ObjectViewDataParams, ObjectViewDataService} from '../../core/object-view-data.service';
import {AConst} from '../../core/a-const.enum';
import { ObjectView, ViewSection } from '../../core/definitions/object-view';
import {ObjectEditService} from '../../core/object-edit.service';
import {SectionsContainer} from '../../core/definitions/sections-container';

@Component({
    selector: 'app-object-view',
    templateUrl: './object-view.component.html',
    styleUrls: ['./object-view.component.scss'],
    standalone: false
})
export class ObjectViewComponent implements OnChanges {
  // Injections
  private readonly objectEditService: ObjectEditService = inject(ObjectEditService);
  private readonly objectViewDataService: ObjectViewDataService = inject(ObjectViewDataService);

  @Input() objectId: string;
  @Input() sectionsContainer: SectionsContainer;
  @Input() templateGroupId: string;
  @Input() hideSectionTitle;
  @Input() noHr;

  AConst = AConst;
  objectViewData: ObjectView;

  ngOnChanges(changes:SimpleChanges) {
    const templateGroupIdChange = Boolean(changes['templateGroupId']);
    if (!this.sectionsContainer) {
      this.objectEditService.loadObjectGetSectionsContainer(this.objectId, false, this.templateGroupId).then(sectionsContainer => {
        this.sectionsContainer = sectionsContainer;
        this.getObjectViewData(templateGroupIdChange).then(objectViewData => {
          this.objectViewData = objectViewData;
        });
      });
    } else {
      this.getObjectViewData(templateGroupIdChange).then(objectViewData => {
        this.objectViewData = objectViewData;
      });
    }
  }

  sectionShouldHaveRestrictionIndicator(section: ViewSection): boolean {
    return this.objectEditService?.currentObject?.is_restricted && section?.name === 'rights';
  }

  private async getObjectViewData(templateGroupIdChange: boolean) {
    let res;
    const objectViewDataParams = new ObjectViewDataParams();
    objectViewDataParams.objectId = this.objectId;
    objectViewDataParams.templateGroupId = this.templateGroupId;
    if (!templateGroupIdChange && this.sectionsContainer.objectView) {
      res = this.sectionsContainer.objectView;
    } else {
      res = await this.objectViewDataService.createViewData(objectViewDataParams);
    }
    return res;
  }
}
